import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import FamilyCommunityServicesDetails from '../mendepartmentdetails/FamilyCommunityServices'


function FamilyCommunityServices() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Family and Children Services || State of GTS";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="home"
            title="Family & Children Services"
            subtitledown="Department of Family & Children Services"
           />
            <FamilyCommunityServicesDetails/>
        </div>
    </>
  )
}

export default FamilyCommunityServices